import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _PieChartLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { cx: 12, cy: 12, r: 9, stroke: "currentColor" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M12 12h9M12 3v8.938q.001.062.044.106L18 18" })] }) });
}
const PieChartLight = forwardRef(_PieChartLight);
export { PieChartLight };
